import { BackIcon, Button } from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";
import type { PreviousVendor } from "../../contexts/vendor-selection.context";
import { useCart } from "../cart/cart.context";

interface ProductListVendorNavigationProps {
	isCartVendor: boolean;
	selectedVendorId?: string;
	previousVendor?: PreviousVendor;
	onBackToDefault: () => void;
	onRestorePrevious: () => void;
}

const vendorNavigationButtonClassName =
	"md:px-0 min-h-0 md:min-h-14 py-0 md:py-2 *:flex-nowrap *:whitespace-normal";

export const ProductListVendorNavigation = ({
	isCartVendor,
	selectedVendorId,
	previousVendor,
	onBackToDefault,
	onRestorePrevious,
}: ProductListVendorNavigationProps) => {
	const { t } = useTranslation("product");

	const cart = useCart();

	if (!cart.items.length) {
		return null;
	}

	if (isCartVendor && selectedVendorId) {
		return (
			<Button
				data-testid="back-to-default-vendor"
				variant="ghost"
				leftIcon={<BackIcon size={6} />}
				onClick={onBackToDefault}
				className={vendorNavigationButtonClassName}
			>
				<span className="text-start">
					{t("vendor.navigation.backToDefault", {
						name: previousVendor?.name,
					})}
				</span>
			</Button>
		);
	}

	if (!isCartVendor && previousVendor?.id) {
		return (
			<Button
				data-testid="restore-previous-vendor"
				variant="ghost"
				rightIcon={
					<div className="transform scale-x-[-1]">
						<BackIcon size={6} />
					</div>
				}
				onClick={onRestorePrevious}
				className={vendorNavigationButtonClassName}
			>
				<span className="text-start">
					{t("vendor.navigation.goToVendor", { name: previousVendor?.name })}
				</span>
			</Button>
		);
	}

	return null;
};
